export const tableHeadings = ['Image', '', ''];